import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
} from "../../../util/varios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTableFijo from "../../useTableFijo";
import { AgregarDescuento } from "./modalAgregarDescuento";
import axios from "axios";
import moment from "moment";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../ui/buttons/Button";
import { Checkbox, Input, Radio, Select } from "../../../ui/inputs/Input";
export const ConfiguracionModulo = (props) => {
  let heightTabla = 220;
  const headCells = [
    {
      id: "fechaini",
      label: "Periodo Inicio",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "fechafin",
      label: "Periodo Fin",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "dexcuento",
      label: "% Descuento",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtDiaVen = useRef();
  const txtDiaVenQuin1 = useRef();
  const txtDiaVenQuin2 = useRef();
  const radioAnual = useRef();
  const radioTrimestral = useRef();
  const radioMensual = useRef();
  const radioBs = useRef();
  const radioUnidad = useRef();
  const radioPetros = useRef();
  const radioSueldoMin = useRef();
  const radioUtMunicipal = useRef();
  const radioOtroFactor = useRef();
  const radioAnual1 = useRef();
  const radioTrimestral1 = useRef();
  const radioMensual1 = useRef();
  const radioQuincenal = useRef();
  const txtDiaVenReg = useRef();
  const radioValor100 = useRef();
  const radioValor1000 = useRef();
  const radioIntMoraFijo = useRef();
  const txtPorceInt = useRef();
  const radioIntMoraTasa = useRef();
  const txtPorceRecargo = useRef();
  const chkEnero = useRef();
  const chkFebrero = useRef();
  const chkMarzo = useRef();
  const chkAbril = useRef();
  const chkMayo = useRef();
  const chkJunio = useRef();
  const chkJulio = useRef();
  const chkAgosto = useRef();
  const chkSeptiembre = useRef();
  const chkOctubre = useRef();
  const chkNoviembre = useRef();
  const chkDiciembre = useRef();
  const radioBs1 = useRef();
  const radioUnidad1 = useRef();
  const radioPetros1 = useRef();
  const radioSueldoMin1 = useRef();
  const radioUtMunicipal1 = useRef();
  const radioOtroFactor1 = useRef();
  const txtValor = useRef();
  const radioSi = useRef();
  const radioNo = useRef();
  const cmbMes = useRef();
  const cmbAnio = useRef();

  const [operacion, setOperacion] = useState(0);
  const [itemSelect, setItemSelect] = useState(-1);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [tipoconf, setTipoconf] = useState(0);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [inputDisabled, setInputDisabled] = useState(true);
  const [values, setValues] = useState({
    periodopag: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: "0,00",
    porcentajerecarg: "0,00",
    mesesdecladef: "0,00",
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: "0,00",
    diavendeudare: 0,
    declaracionwe: false,
    notifrit: false,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: "0,00",
  });
  const [visible, setVisible] = useState({
    grupo0: "visible",
    grupo1: "visible",
    grupo2: "visible",
    grupo3: "visible",
    grupo4: "collapse",
    grupo5: "visible",
    grupo6: "visible",
    grupo7: "visible",
    grupo8: "visible",
    grupo9: "visible",
    grupo10: "visible",
    grupo11: "visible",
    txtdiaven: "visible",
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    heightTabla
  );

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setItemSelect(-1);
    setRecords([]);
  };

  const crearMovimientoWeb = () => {
    let endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${2}`;
    let body;
    setActivate(true);
    body = {
      idmovi: 0,
      nomtabla: "configindustria",
      idtab: 0,
      fecmovi: fechaSistema,
      riff: null,
      idcomer: null,
      idact: null,
      nanio: null,
      mess: null,
      tipdecla: null,
      numfac: null,
      prefac: null,
      operaper: 2,
      actu: false,
      nmes: null,
      tip: null,
      peri: null,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
    setActivate(true);
  };
  const seleccionarDescuento = () => {
    let campos = "*";
    let nomtab = "tabladescuentos";
    let nomid = "tipoimpuesto";
    let id = 1;
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const actualizar = () => {
    var meses = "",
      diavenqui1,
      diavenqui2;
    var declaweb = false;
    var periodo, tipint, cmbmes, cmbanio;
    var porint, porrec;

    if (radioSi.current.checked) {
      declaweb = true;
    } else {
      declaweb = false;
    }

    if (radioAnual.current.checked) {
      periodo = 1;
    } else if (radioTrimestral.current.checked) {
      periodo = 2;
    } else if (radioMensual.current.checked) {
      periodo = 3;
    } else {
      periodo = 4;
    }

    if (radioIntMoraFijo.current.checked) {
      var por =
        txtPorceInt.current.value.trim() === ""
          ? "0,00"
          : txtPorceInt.current.value.replace(/\./g, "");
      porint = por.replace(",", ".");
      tipint = 1;
    } else {
      porint = 0.0;
      tipint = 2;
    }

    var rec =
      txtPorceRecargo.current.value.trim() === ""
        ? "0,00"
        : txtPorceRecargo.current.value.replace(/\./g, "");
    porrec = rec.replace(",", ".");

    
    if (tipoconf == 1) {
      var pto = 1;
     
     
      if (chkEnero.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkFebrero.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkMarzo.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkAbril.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkMayo.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkJunio.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkJulio.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkAgosto.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkSeptiembre.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkOctubre.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkNoviembre.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      if (chkDiciembre.current.checked) {
        meses = meses + "1";
      } else {
        meses = meses + "0";
      }
      
      var valmul =
        txtValor.current.value.trim() === ""
          ? "0,00"
          : txtValor.current.value.replace(/\./g, "");

     
    }
   
  
    diavenqui1 = parseInt(txtDiaVenQuin1.current.value.trim());
    diavenqui2 = parseInt(txtDiaVenQuin2.current.value.trim());
    cmbmes = parseInt(cmbMes.current.value);
    cmbanio = parseInt(cmbAnio.current.value);

    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);

    body = {
      tipoconf: 1,
      periodo: parseInt(values.periodopag),
      factor: parseInt(values.factorcalcul),
      valor: parseInt(values.valorporcentua),
      decla: parseInt(values.periododeclaracio),
      tipint: parseInt(values.tipointere),
      porint: porint,
      porrec: porrec,
      meses: meses,
      diaven: parseInt(txtDiaVen.current.value),
      diavenreg: txtDiaVenReg.current.value.trim() === ""
          ? 18
          : parseInt(txtDiaVenReg.current.value.trim()),
      pto: parseInt(values.ptoimpr),
      factor1: parseInt(values.factormult),
      valormul: valmul.replace(",", "."),
      declaweb: values.declaracionwe,
      diavenqui1: parseInt(diavenqui1),
      diavenqui2: parseInt(diavenqui2),
      cmbMes: cmbmes,
      descu: records,
      annio: cmbanio,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          crearMovimientoWeb();

          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Configuración Actualizada.",
            icono: "exito",
          });

          seleccionnarModulo();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });

    setActivate(true);
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = event.target.value;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const seleccionnarModulo = () => {
    let nomtab = "configindustria";
    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
          if (response.data !== "") {
            if (response.data.periodopag === 1) {
              radioAnual.current.checked = true;
            } else if (response.data.periodopag === 2) {
              radioTrimestral.current.checked = true;
            } else if (response.data.periodopag === 3) {
              radioMensual.current.checked = true;
            }

            if (response.data.periododeclaracio === 1) {
              radioAnual1.current.checked = true;
              setVisible({
                ...visible,
                txtdiaven: "visible",
                grupo11: "collapse",
              });
            } else if (response.data.periododeclaracio === 2) {
              radioTrimestral1.current.checked = true;
              setVisible({
                ...visible,
                txtdiaven: "visible",
                grupo11: "collapse",
              });
            } else if (response.data.periododeclaracio === 3) {
              radioMensual1.current.checked = true;
              setVisible({
                ...visible,
                txtdiaven: "visible",
                grupo11: "collapse",
              });
              txtDiaVen.current.value = response.data.diavendeud.toString();
            } else {
              radioQuincenal.current.checked = true;
              setVisible({
                ...visible,
                txtdiaven: "visible",
                grupo11: "visible",
              });
              txtDiaVen.current.value = response.data.diavendeud.toString();
            }

            cmbMes.current.value = response.data.mesdesdequincen.toString();
            cmbAnio.current.value = response.data.aniodesdequincena.toString();

            txtDiaVenReg.current.value = response.data.diavendeudare.toString();

            if (response.data.factorcalcul === 1) {
              radioBs.current.checked = true;
            } else if (response.data.factorcalcul === 2) {
              radioUnidad.current.checked = true;
            } else if (response.data.factorcalcul === 3) {
              radioPetros.current.checked = true;
            } else if (response.data.factorcalcul === 4) {
              radioSueldoMin.current.checked = true;
            } else if (response.data.factorcalcul === 5) {
              radioUtMunicipal.current.checked = true;
            } else if (response.data.factorcalcul === 6) {
              radioOtroFactor.current.checked = true;
            }

            if (response.data.valorporcentua === 1) {
              radioValor100.current.checked = true;
            } else {
              radioValor1000.current.checked = true;
            }

            var n1 = response.data.porcentajerecarg;
            txtPorceRecargo.current.value =
              n1 !== null
                ? formatMoneda(n1.toString().replace(".", ","), ",", ".", 2)
                : "0,00";

            if (response.data.mesesdecladef !== null) {
              if (response.data.mesesdecladef.substring(0, 1) === "1") {
                chkEnero.current.checked = true;
              } else {
                chkEnero.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(1, 2) === "1") {
                chkFebrero.current.checked = true;
              } else {
                chkFebrero.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(2, 3) === "1") {
                chkMarzo.current.checked = true;
              } else {
                chkMarzo.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(3, 4) === "1") {
                chkAbril.current.checked = true;
              } else {
                chkAbril.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(4, 5) === "1") {
                chkMayo.current.checked = true;
              } else {
                chkMayo.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(5, 6) === "1") {
                chkJunio.current.checked = true;
              } else {
                chkJunio.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(6, 7) === "1") {
                chkJulio.current.checked = true;
              } else {
                chkJulio.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(7, 8) === "1") {
                chkAgosto.current.checked = true;
              } else {
                chkAgosto.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(8, 9) === "1") {
                chkSeptiembre.current.checked = true;
              } else {
                chkSeptiembre.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(9, 10) === "1") {
                chkOctubre.current.checked = true;
              } else {
                chkOctubre.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(10, 11) === "1") {
                chkNoviembre.current.checked = true;
              } else {
                chkNoviembre.current.checked = false;
              }
              if (response.data.mesesdecladef.substring(11, 12) === "1") {
                chkDiciembre.current.checked = true;
              } else {
                chkDiciembre.current.checked = false;
              }
            }

            if (response.data.factormult === 1) {
              radioBs1.current.checked = true;
            } else if (response.data.factormult === 2) {
              radioUnidad1.current.checked = true;
            } else if (response.data.factormult === 3) {
              radioPetros1.current.checked = true;
            } else if (response.data.factormult === 4) {
              radioSueldoMin1.current.checked = true;
            } else if (response.data.factormult === 5) {
              radioUtMunicipal1.current.checked = true;
            } else if (response.data.factormult === 6) {
              radioOtroFactor1.current.checked = true;
            }

            var n2 = response.data.valormult;
            txtValor.current.value =
              n2 !== null
                ? formatMoneda(n2.toString().replace(".", ","), ",", ".", 2)
                : "0,00";

            if (response.data.declaracionwe) {
              radioSi.current.checked = true;
            } else {
              radioNo.current.checked = true;
            }

            txtDiaVenQuin1.current.value = response.data.diavendeuda1;
            txtDiaVenQuin2.current.value = response.data.diavendeuda2;
            seleccionarDescuento();
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const [anio, setAnio] = useState();

  useEffect(() => {
    const currentYear = moment.utc().year();
    const years = [];
    for (let year = 2022; year <= currentYear; year++) {
      years.push({ anio: year });
    }
    setAnio(years);
  }, []);

  const cancelar = () => {
    blanquear();
    props.setShow(false);
    props.setTabla()
  };

  const onChangeChecked = (e) => {
    if (e.target.name === "periodopag") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "tipointere") {
      if (parseInt(e.target.value) === 1) {
        txtPorceInt.current.value = "0,00";
        setInputDisabled(false);
      } else if (parseInt(e.target.value) === 2) {
        txtPorceInt.current.value = "0,00";
        setInputDisabled(true);
      }
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "periododeclaracio") {
      if (radioAnual1.current.checked) {
        setVisible({ ...visible, txtdiaven: "visible", grupo11: "collapse" });
      } else if (radioTrimestral1.current.checked) {
        setVisible({ ...visible, txtdiaven: "visible", grupo11: "collapse" });
      } else if (radioMensual1.current.checked) {
        setVisible({ ...visible, txtdiaven: "visible", grupo11: "collapse" });
      } else if (radioQuincenal.current.checked) {
        setVisible({ ...visible, txtdiaven: "visible", grupo11: "visible" });
      }
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "valorporcentua") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "factorcalcul") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "declaracionwe") {
      setValues({
        ...values,
        [e.target.name]: e.target.value === "true" ? true : false,
      });
    } else if ((e.target.name = "factormult")) {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    }
  };

  const onChangeChecked2 = (e) => {
    if (e.target.name === "puerto") {
      setValues({ ...values, ptoimpr: parseInt(e.target.value) });
    }
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
  };

  const handleAgregarDescuento = (oper) => (e) => {
    e.preventDefault();
    setOperacion(oper);
    setMostrar1(true);
  };

  const handleCancelaDescuento = () => {
    setMostrar1(false);
    setItemSelect(-1);
  };

  const handleAceptaDescuento = (pini, pfin, porce) => {
    if (operacion === 1) {
      var valporce = porce === "" ? "0.00" : porce.replace(/\./g, "");
      var valorporce = valporce.replace(",", ".");

      setRecords([
        ...records,
        {
          tipoimpuesto: 1,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: valorporce,
        },
      ]);
    } else if (operacion === 2) {
      var i;
      var datos = [];
      for (i = 0; i < records.length; i++) {
        if (i !== itemSelect) {
          datos.push(records[i]);
        }
      }

      setItemSelect(-1);
      setRecords([
        ...datos,
        {
          tipoimpuesto: 1,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: porce,
        },
      ]);
    }
  };

  const handleRemove = (e) => {
    e.preventDefault();

    var i;
    var datos = [];
    for (i = 0; i < records.length; i++) {
      if (i !== itemSelect) {
        datos.push(records[i]);
      }
    }

    setItemSelect(-1);
    setRecords(datos);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTipoconf(props.tipoconf);
        seleccionnarModulo();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          Configuración Actividad Economica
        </h3>
        <a type='button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-12 col-lg-8 m-0 p-0 d-flex flex-wrap">
          <div className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded"
            style={{ visibility: visible.grupo0 }}
          >
            <span className="fw-bold col-auto m-0 p-0">Periódo de Pagos:</span>
            <div className="col m-0 p-0">
              <Radio
                label="Anual"
                ref={radioAnual}
                defaultChecked={values.periodopag === 1 ? true : false}
                value={1}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopag1"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Trimestral"
                ref={radioTrimestral}
                defaultChecked={values.periodopag === 2 ? true : false}
                value={2}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopag2"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Mensual"
                ref={radioMensual}
                defaultChecked={values.periodopag === 3 ? true : false}
                value={3}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopag3"
              />
            </div>
          </div>
          <div className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded"
            style={{ visibility: visible.grupo9 }}
          >
            <span className="fw-bold col-auto m-0 p-0">
              Intereses por Mora:
            </span>
            <div className="col m-0 p-0">
              <Radio
                label="Fijo"
                ref={radioIntMoraFijo}
                onChange={onChangeChecked}
                defaultChecked={values.tipointere === 1 ? true : false}
                name="tipointere"
                value={1}
                id="tipointere1"
              />
            </div>
            <div className="col m-0 p-0">
              <Input
                ref={txtPorceInt}
                disabled={inputDisabled}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Según Tasa"
                ref={radioIntMoraTasa}
                onChange={onChangeChecked}
                defaultChecked={values.tipointere === 2 ? true : false}
                name="tipointere"
                value={2}
                id="tipointere2"
              />
            </div>
          </div>
          <div className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded"
            style={{ visibility: visible.grupo2 }}
          >
            <span className="fw-bold col-auto m-0 p-0">
              Periódo de Declaración:
            </span>
            <div className="col m-0 p-0">
              <Radio
                label="Anual"
                ref={radioAnual1}
                onChange={onChangeChecked}
                defaultChecked={values.periododeclaracio === 1 ? true : false}
                value={1}
                name="periododeclaracio"
                id="flexRadioDisabled"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Trimestral"
                ref={radioTrimestral1}
                onChange={onChangeChecked}
                defaultChecked={values.periododeclaracio === 2 ? true : false}
                value={2}
                name="periododeclaracio"
                id="flexRadioDisabled"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Mensual"
                ref={radioMensual1}
                onChange={onChangeChecked}
                defaultChecked={values.periododeclaracio === 3 ? true : false}
                value={3}
                name="periododeclaracio"
                id="flexRadioDisabled"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="Quincenal"
                ref={radioQuincenal}
                onChange={onChangeChecked}
                defaultChecked={values.periododeclaracio === 4 ? true : false}
                value={4}
                name="periododeclaracio"
                id="flexRadioDisabled"
              />
            </div>
          </div>
          <div className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded"
            style={{ visibility: visible.grupo9 }}
          >
            <span className="fw-bold col-auto m-0 p-0">% Descuento:</span>
            <div className="col m-0 p-0">
              <Input
                ref={txtPorceRecargo}
                defaultValue={
                  values.porcentajerecarg
                    ? formatMoneda(
                      values.porcentajerecarg.toString().replace(".", ","),
                      ",",
                      ".",
                      2
                    )
                    : "0,00"
                }
                name="porcentajerecarg"
                onChange={onChangeChecked}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
              />
            </div>
          </div>
          <div className="col-12 col-xl-6 m-0 mb-2 mb-xl-0 p-2 d-flex gap-2 border-azul rounded"
            style={{ visibility: visible.grupo9 }}
          >
            <span className="fw-bold col-auto m-0 p-0">
              Valor Porcentual Alicuota:
            </span>
            <div className="col m-0 p-0">
              <Radio
                label="100"
                className="form-check-input my-auto"
                ref={radioValor100}
                type="radio"
                onChange={onChangeChecked}
                defaultChecked={values.valorporcentua === 1 ? true : false}
                value={1}
                name="valorporcentua"
                id="valorporcentua1"
              />
            </div>
            <div className="col m-0 p-0">
              <Radio
                label="1000"
                ref={radioValor1000}
                onChange={onChangeChecked}
                defaultChecked={values.valorporcentua === 2 ? true : false}
                value={2}
                name="valorporcentua"
                id="valorporcentua2"
              />
            </div>
          </div>
          <div className="col-12 col-xl-6 m-0 mb-2 mb-xl-0 p-0 pl-xl-2">
            <div className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
              <span className="fw-bold col-auto m-0 p-0">
                Declaración en Linea (Internet):
              </span>
              <div className="col m-0 p-0">
                <Radio
                  label="Si"
                  ref={radioSi}
                  onChange={onChangeChecked}
                  defaultChecked={values.declaracionwe === true ? true : false}
                  value={true}
                  name="declaracionwe"
                  id="declaracionwe1"
                />
              </div>
              <div className="col m-0 p-0">
                <Radio
                  label="No"
                  ref={radioNo}
                  onChange={onChangeChecked}
                  defaultChecked={values.declaracionwe === false ? true : false}
                  value={false}
                  name="declaracionwe"
                  id="declaracionwe2"
                />
              </div>
            </div>
          </div>
          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded"
            style={{ visibility: visible.grupo3 }}
          >
            <legend className="float-none w-auto m-0">
              Meses de Pago Declaración Definitiva
            </legend>
            <div className="col m-0 p-0">
              <Checkbox
                label="1"
                ref={chkEnero}
                id="mesesdecla1"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(0, 1) === "1"
                    ? true
                    : false
                }
                name="flexRadioDisabled"
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="2"
                ref={chkFebrero}
                id="mesesdecla2"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(1, 2) === "1"
                    ? true
                    : false
                }
                name="mesesdecla"
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="3"
                ref={chkMarzo}
                id="mesesdecla3"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(2, 3) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="4"
                ref={chkAbril}
                id="mesesdecla4"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(3, 4) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="5"
                ref={chkMayo}
                id="mesesdecla5"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(4, 5) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="6"
                ref={chkJunio}
                id="mesesdecla6"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(5, 6) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="7"
                ref={chkJulio}
                id="mesesdecla7"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(6, 7) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="8"
                ref={chkAgosto}
                id="mesesdecla8"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(7, 8) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="9"
                ref={chkSeptiembre}
                id="mesesdecla9"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(8, 9) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="10"
                ref={chkOctubre}
                id="mesesdecla10"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(9, 10) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="11"
                ref={chkNoviembre}
                id="mesesdecla11"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(10, 11) === "1"
                    ? true
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox
                label="12"
                ref={chkDiciembre}
                id="mesesdecla12"
                name="mesesdecla"
                defaultChecked={
                  values.mesesdecladef &&
                    values.mesesdecladef.substring(11, 12) === "1"
                    ? true
                    : false
                }
              />
            </div>
          </fieldset>
        </div>
        <div className="col-12 col-lg-4 m-0 mt-2 mt-lg-0 p-0 pl-lg-2 d-flex"
          style={{ visibility: visible.grupo10 }}
        >
          <div className="col-10 m-0 p-0">
            <TblContainer
              container={{
                height: 250,
                width: "100%",
                overflow: "auto",
                padding: "2px",
              }}
            >
              <TblHead />
              <tbody>
                {records &&
                  records.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        padding: "0",
                        background:
                          itemSelect === index ? "lightgreen" : "white",
                      }}
                      onClick={seleccionarFila(index)}
                    >
                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        {item.periodoini}
                      </td>
                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        {item.periodofin}
                      </td>
                      <td style={{ fontSize: "10px", textAlign: "right" }}>
                        {formatMoneda(
                          item.porcentaje.toString().replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
          <div
            className="col-2 m-0 p-0 d-flex flex-column justify-content-center align-items-center gap-2"
            style={{ visibility: visible.grupo10 }}
          >
            <PrimaryButton
              icon="fa-plus m-0"
              onClick={handleAgregarDescuento(1)}
            />
            <WarningButton
              icon="fa-edit m-0"
              disabled={itemSelect === -1 ? true : false}
              onClick={handleAgregarDescuento(2)}
            />
            <DangerButton
              icon="fa-trash-alt m-0"
              disabled={itemSelect === -1 ? true : false}
              onClick={handleRemove}
            />
          </div>
        </div>
        <fieldset className="col-12 col-lg-6 m-0 p-2 d-flex flex-wrap border-azul rounded"
          style={{ visibility: visible.grupo0 }}
        >
          <legend className="float-none w-auto m-0">
            Factor para el Cálculo del Minimo Tributable
          </legend>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Bolivares (Bs.)"
              ref={radioBs}
              onChange={onChangeChecked}
              defaultChecked={values.factorcalcul === 1 ? true : false}
              value={1}
              name="factorcalcul"
              id="factorcalcul1"
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Sueldo Minimo"
              ref={radioSueldoMin}
              onChange={onChangeChecked}
              defaultChecked={values.factorcalcul === 4 ? true : false}
              value={4}
              name="factorcalcul"
              id="factorcalcul2"
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="UCAMP"
              ref={radioUtMunicipal}
              onChange={onChangeChecked}
              defaultChecked={values.factorcalcul === 5 ? true : false}
              value={5}
              name="factorcalcul"
              id="factorcalcul3"
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Petros"
              ref={radioPetros}
              onChange={onChangeChecked}
              defaultChecked={values.factorcalcul === 3 ? true : false}
              value={3}
              name="factorcalcul"
              id="factorcalcul4"
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="UT Unidades Tributarias"
              ref={radioUnidad}
              type="radio"
              defaultChecked={values.factorcalcul === 2 ? true : false}
              value={2}
              name="factorcalcul"
              id="factorcalcul5"
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Otros"
              ref={radioOtroFactor}
              onChange={onChangeChecked}
              defaultChecked={values.factorcalcul === 6 ? true : false}
              value={6}
              name="factorcalcul"
              id="factorcalcul6"
            />
          </div>
        </fieldset>
        <div className="col-12 col-lg-6 m-0 p-0 pl-lg-2">
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded"
            style={{ visibility: visible.grupo5 }}
          >
            <legend className="float-none w-auto m-0">
              Factor para el Cálculo de la Multa
            </legend>
            <div className="col-4 m-0 p-0">
              <Radio
                label="Bolivares (Bs.)"
                ref={radioBs1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 1 ? true : false}
                value={1}
                name="factormult"
                id="factormult1"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Radio
                label="Sueldo Minimo"
                ref={radioSueldoMin1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 4 ? true : false}
                value={4}
                name="factormult"
                id="factormult2"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Radio
                label="UCAMP"
                ref={radioUtMunicipal1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 5 ? true : false}
                value={5}
                name="factormult"
                id="factormult3"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Radio
                label="Petros"
                ref={radioPetros1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 3 ? true : false}
                value={3}
                name="factormult"
                id="factormult4"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Radio
                label="UT Unidades Tributarias"
                ref={radioUnidad1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 2 ? true : false}
                value={2}
                name="factormult"
                id="factormult5"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Radio
                label="Otros"
                ref={radioOtroFactor1}
                onChange={onChangeChecked}
                defaultChecked={values.factormult === 6 ? true : false}
                value={6}
                name="factormult"
                id="factormult6"
              />
            </div>
          </fieldset>
        </div>
        <div className="col-12 m-0 p-0 mt-2">
          <div className="col-12 m-0 mb-xl-2 p-0 d-flex flex-wrap" style={{ visibility: visible.grupo11 }}>
            <div className="col-12 col-lg-6 col-xl-4 m-0 mb-2 mb-xl-0 p-0">
              <Select
                label="Declaración Quincenal Desde:"
                name="cmbMes"
                ref={cmbMes}
              >
                <option value={1}>ENERO</option>
                <option value={2}>FEBRERO</option>
                <option value={3}>MARZO</option>
                <option value={4}>ABRIL</option>
                <option value={5}>MAYO</option>
                <option value={6}>JUNIO</option>
                <option value={7}>JULIO</option>
                <option value={8}>AGOSTO</option>
                <option value={9}>SEPTIEMBRE</option>
                <option value={10}>OCTUBRE</option>
                <option value={11}>NOVIEMBRE</option>
                <option value={12}>DICIEMBRE</option>
              </Select>
            </div>
            <div className="col-12 col-lg-6 col-xl-3 m-0 mb-2 mb-xl-0 p-0 pl-lg-2">
              <Input
                label="Dia Limite Primera Quincena:"
                ref={txtDiaVenQuin1}
                defaultValue={values.diavendeuda1}
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
                id="txtDiaVenQuin1"
                maxLength={2}
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-3 m-0 mb-2 mb-xl-0 p-0 pl-xl-2">
              <Input
                label="Dia Limite Segunda Quincena:"
                ref={txtDiaVenQuin2}
                defaultValue={values.diavendeuda2}
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
                id="txtDiaVenQuin2"
                maxLength={2}
              />
            </div>
            <div className="col-6 col-lg-2 m-0 mb-2 mb-lg-0 p-0 pl-lg-2">
              <Select label="Año:" name="cmbMes" ref={cmbAnio}>
                {anio &&
                  anio.map((year, index) => (
                    <option key={index} value={year.anio}>
                      {year.anio}
                    </option>
                  ))}
              </Select>
            </div>
          </div>
          <div className="col-12 m-0 p-0 d-flex flex-wrap align-items-center">
            <div className="col-12 col-lg-4 m-0 mb-2 mb-lg-0 p-0"
              style={{ visibility: visible.txtdiaven }}
            >
              <Input
                label="Dia Limite de Pago:"
                ref={txtDiaVen}
                defaultValue={values.diavendeud}
                onKeyUp={handleInputNumChange}
                maxLength={2}
                onBlur={handleInputNumChange}
                id="txtDiaVen"
              />
            </div>
            <div className="col-12 col-lg-5 m-0 mb-2 mb-lg-0 p-0 pl-lg-2"
              style={{ visibility: visible.grupo6 }}
            >
              <Input
                label="Dia Limite de Pago Declaración Regular:"
                ref={txtDiaVenReg}
                defaultValue={values.diavendeudare}
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
                id="txtDiaVenReg"
                maxLength={2}
              />
            </div>
            <div className="col-12 col-lg-3 m-0 p-0 pl-lg-2">
              <Input
                label="Valor:"
                ref={txtValor}
                defaultValue={
                  values.valormult
                    ? formatMoneda(
                      values.valormult.toString().replace(".", ","),
                      ",",
                      ".",
                      2
                    )
                    : ""
                }
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
              />
            </div>
            <fieldset className="col-12 col-lg-6 col-xl-3 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none w-auto m-0"> Puerto:</legend>

              <div className="col m-0 p-0">
                <Radio label="USB"
                  onChange={onChangeChecked2}
                  defaultChecked={values.ptoimpr === 1 ? true : false}
                  name="puerto"
                  value={1}
                  id="radioUSB"
                />
              </div>
              <div className="col m-0 p-0">
                <Radio label="Paralelo"
                  onChange={onChangeChecked2}
                  defaultChecked={values.ptoimpr === 2 ? true : false}
                  name="puerto"
                  value={2}
                  id="radioParalelo"
                />
              </div>
              <div className="col m-0 p-0">
                <Radio label="Serial"
                  onChange={onChangeChecked2}
                  defaultChecked={values.ptoimpr === 3 ? true : false}
                  name="puerto"
                  value={3}
                  id="radioSerial"
                />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton ref={btnAcepta} onClick={actualizar}>
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <AgregarDescuento
        show={mostrar1}
        tipoconf={operacion}
        descuento={records[itemSelect]}
        onHideAcepta={handleAceptaDescuento}
        onHideCancela={handleCancelaDescuento}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
